import { fetchApi } from '@/config/axiosSetting';
import {
  GetBodyAdjusterAttachedDocumentImagesQueryParamsType,
  GetBodyAdjusterAttachedDocumentImagesQueryResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyAdjusterAttachedDocumentImages/getBodyAdjusterAttachedDocumentImagesQuery.type';

export const getBodyAdjusterAttachedDocumentImagesQueryFunction = (
  params: GetBodyAdjusterAttachedDocumentImagesQueryParamsType,
): Promise<GetBodyAdjusterAttachedDocumentImagesQueryResponseType> => {
  return fetchApi.get(
    `/body/reports/${params.id}/images/adjuster/additional/document/`,
    { params },
  );
};
